import React, { useState, useMemo } from 'react'
import { intCol, strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import { UtilityUnitSelection } from 'core'
import { connect } from 'react-redux'
import { Select, Button, InputNumber, Input } from 'antd'
import { Label } from 'core/screen-util'
import MultiCauseCodePropmt from 'card-data/MultiCauseCode'
import {
  modifiedDateCol,
  modifierCol,
  utilityHeader,
  unitIdHeader,
  YNBooleanTypes,
} from 'core/HeaderColTypeProps'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getCauseCodeMap,
} from 'core/selectors'
import {
  getCausecodeAlertlist,
  saveCausecodeAlertlist,
  deleteCausecodeAlertlist,
} from '../api/pgads'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

const title = 'Causecode Watchlist'

const CausecodeAlertlist = ({ utilityNameMap, unitNameMap, causecodeMap }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const headerWithFormatter = useMemo(
    _ =>
      CausecodeAlertlistHeaders.map(h =>
        h.ident === 'utility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : h.ident === 'unitId'
          ? {
              ...h,
              choices: [],
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : h
      ),
    [unitNameMap, utilityNameMap]
  )

  const [selectCauseCode, setSelectCauseCode] = useState({ open: false })
  const openCauseCodePrompt = d => setSelectCauseCode({ open: d })

  const onCauseCodeTreeCancel = causeCodeKeyValues => {
    setSelectCauseCode({
      causeCodeKeyValues,
      open: false,
    })
  }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    const onCauseCodeDialogClose = (causeCodeKeyValues, causeCodeValues) => {
      setInsertData({
        ...insertData,
        causecode: (causeCodeValues[0] || {}).causeCode,
      })
      setSelectCauseCode({
        open: false,
        causeCodeKeyValues,
        causeCodeValues,
        causeCode: causeCodeValues
          ? (causeCodeValues || []).length > 0
            ? causeCodeValues[0].causeCode
            : ''
          : selectCauseCode.causeCode,
      })
    }

    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '150px 100px 100px 100px 50px 200px 100px 350px',
          width: '100%',
          gap: '5px',
        }}
      >
        <Label>Causecode : </Label>
        {selectCauseCode.open && (
          <MultiCauseCodePropmt
            key="card97editcausecodeprompt"
            // style={{ ...inlineStyle }}
            // checkable={false}
            visibleDialog={selectCauseCode.open}
            onDialogClose={onCauseCodeDialogClose}
            onCancelAction={onCauseCodeTreeCancel}
            // defaultExpandedKeys={causeCode ? causeCode.selectedKeys : []}
            defaultExpandedKeys={
              selectCauseCode.causeCodeKeyValues
                ? selectCauseCode.causeCodeKeyValues
                : []
            }
            // selectedKeys={this.state.causeCodeKeyValues ? this.state.causeCodeKeyValues : []}
            selectedKeys={selectCauseCode.causeCodeKeyValues}
            selectedValues={selectCauseCode.causeCodeValues}
            // selectedValues={this.state.causeCodeValues || []}
            unitCodes={[]}
            multiple={false}
            checkable={false}
            selectable
            causeCodeValue={selectCauseCode.causeCodeValues || []}
          />
        )}
        <InputNumber
          style={{ width: '100%' }}
          onChange={e => setInsertData({ ...insertData, causecode: e })}
          value={insertData.causecode}
        />
        <Button style={{ width: '100%' }} onClick={openCauseCodePrompt}>
          Select
        </Button>
        <Input
          style={{ gridColumnEnd: 'span 3' }}
          value={causecodeMap[insertData.causecode]}
          onChange={_ => {}}
          disabled
        />

        <Label>Note : </Label>
        <Input
          // value={causecodeMap[insertData.note]}
          style={{ gridColumnEnd: 'span 1' }}
          value={insertData.note}
          onChange={e => setInsertData({ ...insertData, note: e.target.value })}
          maxLength={15}
        />
        <Label>All Units : </Label>
        <Select
          value={insertData.allUnits}
          onChange={e => setInsertData({ ...insertData, allUnits: e })}
        >
          <Select.Option key="Y">Yes</Select.Option>
          <Select.Option key="N">No</Select.Option>
        </Select>
        <Label>Utility / Unit : </Label>
        <UtilityUnitSelection
          style={{ gridColumnEnd: 'span 3' }}
          utility={insertData.utility}
          unit={insertData.unitId}
          onUnitChange={value => {
            // setUtilityUnit(value)
            setInsertData({
              ...insertData,
              utility: value[0],
              unitId: value[1],
              unit: value[1].substr(3),
            })
          }}
          disabled={insertData.allUnits === 'Y'}
        />
        <div />
        <div style={{ display: 'flex', gap: '5px' }}>
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }
  const sortOnData = data => {
    return data.map(d => ({
      ...d,
      unitId: (d.utility || '') + '' + (d.unit || ''),
    }))
  }

  return (
    <>
      <CommonScreen
        sortOnData={sortOnData}
        withUnitSelection={false}
        isAdminScreen
        title={title}
        header={headerWithFormatter}
        saveTask={saveCausecodeAlertlist}
        retrieveTask={getCausecodeAlertlist}
        deleteTask={deleteCausecodeAlertlist}
        altBy={d => d.unitId}
        autoRetrieve
        sortOptions={CausecodeAlertlistHeaders}
        widthOffset={50}
        heightOffset={220}
        insertComp={insertEvent && insertComp}
        onInsertEvent={b => setInsertEvent(b)}
        insertCompHeight={0}
        autoFixColByKey={false}
        headerRowHeight={60}
      />
    </>
  )
}

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  causecodeMap: getCauseCodeMap(state),
})

export default connect(mapStateToProps)(CausecodeAlertlist)

export const CausecodeAlertlistHeaders = [
  intCol({
    ident: 'causecode',
    display: 'Causecode',
    isKey: true,
    sortOrder: 'asc',
  }),
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'allUnits',
    display: 'All Units',
    sortOrder: 'asc',
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'note',
    display: 'Note',
    sortOrder: 'asc',
    width: 550,
    ellipsis: true,
    alignment: 'left',
  }),
  modifierCol,
  modifiedDateCol,
]
